import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import locale files
import commonEn from "./locales/en/common.json";
import poolEn from "./locales/en/pool.json";
import portfolioEn from "./locales/en/portfolio.json";

// Define resources
const resources = {
  en: {
    common: commonEn,
    pool: poolEn,
    portfolio: portfolioEn,
  },
  // Add more languages here in the future
  // ja: {
  //   common: commonJa,
  //   pool: poolJa,
  //   portfolio: portfolioJa,
  // },
} as const;

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: "en", // default language
    fallbackLng: "en",
    defaultNS: "common", // default namespace
    ns: ["common", "pool", "portfolio"], // namespaces

    interpolation: {
      escapeValue: false, // react already safes from xss
    },

    // Enable debug in development
    debug: import.meta.env.DEV,
  });

export default i18n;
